import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
    yellowBoxText: {
        background: "#F4B827", padding: "3px 16px", fontSize: 14, fontWeight: 700, color: "#03090E", borderRadius: 4, marginLeft: 5, cursor: "pointer",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }
}));

const YellowBox = ({ title, onClick = null, style = {} }: any): JSX.Element | null  => {
    const classes = useStyles();
    if (!title) return null;
    return (
        <span onClick={onClick} className={classes.yellowBoxText} style={{ ...style }}>
            {title}
        </span>
    )
}

export default YellowBox;